module.exports = __webpack_public_path__ + "img/criteriav2.80faff43.jpg";